"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var OperatorMinus = {
    name: 'OperatorMinus',
    suppressMirroring: true,
    tooltipKey: 'OperatorMinus.icon.label',
    render: function (props, svgRef) {
        return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: ['OperatorMinus', props.className].join(' '), width: "14", height: "14", x: "0", y: "0", version: "1.1", viewBox: "0 0 14 14", xmlSpace: "preserve", ref: svgRef }, props),
            props.tooltip && react_1.default.createElement("title", null, props.tooltip),
            react_1.default.createElement("path", { className: "svgToolTipPane", fill: "none", d: "M14 14H0V0h14v14z" }),
            react_1.default.createElement("path", { className: "iconColor", d: "M2 6h10v2H2V6z" })));
    },
};
exports.default = OperatorMinus;
